# GraphQL fragment to get basic info about a step template
# within the sales automation environment.

#import "./assignable-fragment.graphql"

fragment StepTemplateDueDate on StepDueDate {
    dueFrom
    dueUnit
    dueTimespan
}

fragment SalesAutomationStepTemplate on StepTemplate {
    id
    type
    name
    description
    stage {
        id
    }
    dueDate {
        ...StepTemplateDueDate
    }
    assignee {
        ...SalesAutomationAssignable
    }
}
